import axios from "../../api/axios";
import hbscan from "../../api/hbscan";
import ILocal from "../../models/local";
import { ILocalBuildingDetails } from "../../models/requests/local/localBuildingDetails";
import { ILocalDetail } from "../../models/requests/local/localDetail";
import ILocalEditRequest from "../../models/requests/local/localEditRequest";
import Auth from "../auth/AuthService";

class LocalService {
    PutLocalStatus = async (localId: number, isActive: boolean) => {
        const URI = `/api/hblogin/Local/PutLocalStatus`;
        const data = { localId, isActive };
        return (await axios.put(URI, data, {
            headers: { Authorization: Auth.guid },
        })).data;


    };



    GetAccreditedLocals = async (
        fromDate: Date | null = null,
        toDate: Date | null = null
    ) => {
        const URI = "/api/hblogin/Local/GetLocalsDetails";

        return (
            await axios.post<ILocal[]>(
                URI,
                JSON.stringify({
                    BuildingId: Auth.user?.buildingId,
                    FromTime: fromDate,
                    ToTime: toDate,
                }),
                { headers: { Authorization: Auth.guid } }
            )
        ).data;
    };

    GetLocalsByBuilding = async (buildingId: number) => {
        const URI = "/api/hblogin/Local/GetLocalsByBuilding";

        return (
            await axios.get<ILocal[]>(URI, {
                headers: { Authorization: Auth.guid },
                params: { buildingId },
            })
        ).data;
    };

    // Obtain all rooms for that specific building, regardless of credentials
    GetManagerLocals = async (buildingId: number) => {
        const URI = "/api/hbscan/Local/GetManagerLocals";

        return (
            await hbscan.get<ILocal[]>(URI, {
                headers: { Authorization: Auth.guid },
                params: { buildingId },
            })
        ).data;
    };


    GetLocalById = async (localId: number) => {
        const URI = "/api/hblogin/getlocal";

        return (
            await axios.get<ILocal>(`${URI}/${Auth.guid}/${localId}`, {
                headers: { Authorization: Auth.guid },
            })
        ).data;
    };

    GetLocalsByTenant = async (tenantId: number, buildingId: number) => {
        const URI = "/api/hblogin/Local/GetLocalsByTenant";

        return (
            await axios.get<ILocal[]>(URI, {
                headers: { Authorization: Auth.guid },
                params: { tenantId, buildingId },
            })
        ).data;
    };

    GetLocalsByFloor = async (floorId: number) => {
        const URI = "/api/hblogin/Local/GetLocalsByFloor";

        return (
            await axios.get<ILocal[]>(URI, {
                headers: { Authorization: Auth.guid },
                params: { floorId },
            })
        ).data;
    };

    GetLocalsBuildingsByCompany = async () => {
        const URI = "/api/hblogin/Local/GetLocalsBuildingsByCompany";

        return (
            await axios.get<ILocalBuildingDetails>(URI, {
                headers: { Authorization: Auth.guid },
            })
        ).data || [];
    };

    GetLocalsByCompany = async () => {
        const URI = "/api/hblogin/Local/GetLocalsByCompany";

        return (
            await axios.get<ILocalDetail[]>(URI, {
                headers: { Authorization: Auth.guid },
            })
        ).data || [];
    };
    DeleteLocal = async (localId: number) => {
        const URI = "/api/hblogin/Local/DeleteLocal";

        await axios.delete(URI, {
            headers: { Authorization: Auth.guid },
            params: { localId },
        });
    };

    PostLocal = async (local: ILocalEditRequest) => {
        const URI = "/api/hblogin/Local/PostLocal";
        return (
            await axios.post<number>(URI, JSON.stringify(local), {
                headers: { Authorization: Auth.guid },
            })
        );
    };

    PutLocal = async (local: ILocalEditRequest) => {
        const URI = "/api/hblogin/Local/PutLocal";
        return (
            await axios.put(URI, JSON.stringify(local), {
                headers: { Authorization: Auth.guid },
            }));
    };

    GetAdminLocal = async (localId: number) => {
        const URI = "/api/hblogin/Local/GetAdminLocal";

        return (
            await axios.get<ILocalEditRequest>(URI, {
                headers: { Authorization: Auth.guid },
                params: { localId },
            })
        ).data;
    };

    DeleteLocalTenant = async (localId: number, tenantId: number) => {
        const URI = "/api/hblogin/Local/DeleteLocalTenant";

        await axios.delete(URI, {
            headers: { Authorization: Auth.guid },
            params: { localId, tenantId },
        });
    };

    GetAlarmCode = async (localId: number) => {
        const URI = "/api/hblogin/Local/GetAlarmCode";

        return (
            await axios.get<string>(URI, {
                headers: { Authorization: Auth.guid },
                params: { localId },
            })
        ).data.toString();
    }

    GetLocalsByPropertyGroup = async (propertyGroupId: number) => {
        const URI = "/api/hblogin/Local/GetLocalsByPropertyGroup";

        return (
            await axios.get<ILocalDetail[]>(URI, {
                headers: { Authorization: Auth.guid },
                params: { propertyGroupId },
            })
        ).data;
    };

    GetLocalsByProfileId = async (profileId: number) => {
        const URI = "/api/hblogin/Local/GetLocalsByProfileId";

        return (
            await axios.get<ILocalDetail[]>(URI, {
                headers: { Authorization: Auth.guid },
                params: { profileId },
            })
        ).data;
    };
}

const localService = new LocalService();

export default localService;
